import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './GebruikersBeheer.css';
import api from '../services/api';

const GebruikersBeheer = () => {
  const { gebruiker, logout } = useAuth();
  const navigate = useNavigate();
  const [gebruikers, setGebruikers] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [rollen, setRollen] = useState([
    { id: 1, naam: 'hoofdbeheerder' },
    { id: 2, naam: 'werkvoorbereider' },
    { id: 3, naam: 'monteur' },
    { id: 8, naam: 'manager' }
  ]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    gebruikersnaam: '', email: '', wachtwoord: '', voornaam: '', achternaam: '', rol_id: 3, afdeling_id: ''
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [gebruikersRes, afdelingenRes, rollenRes] = await Promise.all([
        api.get('/gebruikers'),
        api.get('/afdelingen'),
        api.get('/rollen').catch(() => null)
      ]);
      setGebruikers(gebruikersRes.data.gebruikers || []);
      setAfdelingen(afdelingenRes.data.afdelingen || []);
      const dynRollen = rollenRes?.data?.rollen || rollenRes?.data?.data || rollenRes?.data;
      if (Array.isArray(dynRollen) && dynRollen.length > 0) setRollen(dynRollen);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden data:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/gebruikers', formData);
      setShowModal(false);
      setFormData({ gebruikersnaam: '', email: '', wachtwoord: '', voornaam: '', achternaam: '', rol_id: 3, afdeling_id: '' });
      loadData();
    } catch (error) {
      alert(error.response?.data?.message || 'Fout bij aanmaken gebruiker');
    }
  };

  const handleDeactivate = async (id) => {
    if (!window.confirm('Gebruiker deactiveren? (kan later weer geactiveerd worden)')) return;
    try {
      await api.delete(`/gebruikers/${id}`);
      loadData();
    } catch (error) {
      alert('Fout: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleIntrekSessies = async (id, naam) => {
    if (!window.confirm('Alle apparaten van ' + (naam || 'deze gebruiker') + ' uitloggen?\n\nGebruik dit bij verlies of diefstal van een toestel. De gebruiker moet daarna opnieuw met wachtwoord inloggen.')) return;
    try {
      const r = await api.post(`/gebruikers/${id}/intrek-sessies`);
      alert('\u2713 ' + (r.data?.aantal || 0) + ' sessie(s) ingetrokken. Het toestel kan niet meer inloggen zonder wachtwoord.');
    } catch (error) {
      alert('Fout: ' + (error.response?.data?.message || error.message));
    }
  };

  const handlePermanentDelete = async (id) => {
    if (!window.confirm('⚠️ PERMANENT VERWIJDEREN?\n\nDeze actie kan NIET ongedaan gemaakt worden!\n\nAlle geschiedenis van deze gebruiker gaat verloren.')) return;
    try {
      await api.delete(`/gebruikers/${id}/permanent`);
      loadData();
    } catch (error) {
      alert('Fout: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleActivate = async (id) => {
    try {
      await api.post(`/gebruikers/${id}/activeer`);
      loadData();
    } catch (error) {
      alert('Fout: ' + (error.response?.data?.message || error.message));
    }
  };

  const updateRol = async (id, nieuw_rol_id) => {
    if (!nieuw_rol_id) return;
    try {
      await api.put(`/gebruikers/${id}`, { rol_id: parseInt(nieuw_rol_id) });
      loadData();
    } catch (e) {
      alert('Fout bij rol wijzigen: ' + (e.response?.data?.message || e.message));
    }
  };
  const updateInPlanning = async (id, val) => {
    try {
      await api.put(`/gebruikers/${id}`, { in_planning: val });
      loadData();
    } catch (e) {
      alert('Fout bij in_planning wijzigen: ' + (e.response?.data?.message || e.message));
    }
  };
  const updateMonteurPush = async (id, val) => {
    try {
      await api.put(`/gebruikers/${id}`, { ontvangt_monteur_push: val });
      loadData();
    } catch (e) {
      alert('Fout bij push-instelling wijzigen: ' + (e.response?.data?.message || e.message));
    }
  };

  const updateAfdeling = async (id, nieuw_afdeling_id) => {
    try {
      await api.put(`/gebruikers/${id}`, { afdeling_id: nieuw_afdeling_id ? parseInt(nieuw_afdeling_id) : null });
      loadData();
    } catch (e) {
      alert('Fout bij afdeling wijzigen: ' + (e.response?.data?.message || e.message));
    }
  };

  return (
    <>
      <div className="gebruikers-beheer">
        <div className="dashboard-container">
          <div className="dashboard-header">
            <h1>👥 Gebruikers Beheer</h1>
          </div>

          <div style={{ padding: '15px 0', borderBottom: '1px solid #e5e7eb', marginBottom: '20px' }}>
            <button onClick={() => setShowModal(true)} className="btn-primary">+ Nieuwe Gebruiker</button>
          </div>

          <div className="werkorders-section">
            <h2>Gebruikers Overzicht</h2>
            {loading ? (
              <div className="loading">Laden...</div>
            ) : (
              <div className="werkorders-list">
                {gebruikers.map(gbr => (
                  <div key={gbr.id} className={`werkorder-card ${!gbr.actief ? 'inactive' : ''}`}>
                    <div className="werkorder-header">
                      <div className="werkorder-title-row">
                        <h3 style={{cursor:'pointer',color:'#3b82f6'}} onClick={() => navigate(`/gebruiker/${gbr.id}`)}>👤 {gbr.voornaam} {gbr.achternaam}</h3>
                        <span className={`badge ${!gbr.actief ? 'badge-inactive' : 'badge-nieuw'}`}>
                          {gbr.actief ? 'Actief' : 'Inactief'}
                        </span>
                      </div>
                    </div>
                    <div className="werkorder-meta">
                      <span>👤 {gbr.gebruikersnaam}</span>
                      <span>📧 {gbr.email}</span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>🏢
                        <select
                          value={gbr.afdeling_id || ''}
                          onChange={(e) => updateAfdeling(gbr.id, e.target.value)}
                          style={{ padding: '2px 6px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 12, background: 'white' }}
                          title="Wijzig afdeling"
                        >
                          <option value="">Geen afdeling</option>
                          {afdelingen.map(afd => <option key={afd.id} value={afd.id}>{afd.naam}</option>)}
                        </select>
                      </span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>🔑
                        <select
                          value={gbr.rol_id || (rollen.find(r => r.naam === gbr.rol)?.id) || ''}
                          onChange={(e) => updateRol(gbr.id, e.target.value)}
                          style={{ padding: '2px 6px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 12, background: 'white' }}
                          title="Wijzig rol"
                        >
                          {rollen.map(r => <option key={r.id} value={r.id}>{r.naam}</option>)}
                        </select>
                      </span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, cursor: 'pointer', userSelect: 'none' }} title="Verschijnt in planning/onderhoud-monteurlijsten">
                          <input
                            type="checkbox"
                            checked={!!gbr.in_planning}
                            onChange={(e) => updateInPlanning(gbr.id, e.target.checked)}
                            style={{ cursor: 'pointer' }}
                          />
                          📅 In planning
                        </label>
                      </span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, cursor: 'pointer', userSelect: 'none' }} title="Ontvangt de dagelijkse afdelings-pushberichten">
                          <input
                            type="checkbox"
                            checked={!!gbr.ontvangt_monteur_push}
                            onChange={(e) => updateMonteurPush(gbr.id, e.target.checked)}
                            style={{ cursor: 'pointer' }}
                          />
                          🔔 Push
                        </label>
                      </span>
                    </div>
                    <div className="gebruiker-actions" style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                      {gbr.actief ? (
                        <>
                          <button onClick={() => handleDeactivate(gbr.id)} className="btn-secondary" style={{ fontSize: '13px', padding: '6px 12px' }}>Deactiveren</button>
                          <button onClick={() => handleIntrekSessies(gbr.id, gbr.voornaam + ' ' + gbr.achternaam)} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>🔒 Apparaten uitloggen</button>
                          <button onClick={() => handlePermanentDelete(gbr.id)} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>Permanent Verwijderen</button>
                        </>
                      ) : (
                        <>
                          <button onClick={() => handleActivate(gbr.id)} className="btn-primary" style={{ fontSize: '13px', padding: '6px 12px' }}>Activeren</button>
                          <button onClick={() => handlePermanentDelete(gbr.id)} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>Permanent Verwijderen</button>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Nieuwe Gebruiker</h2>
              <button onClick={() => setShowModal(false)} className="btn-close">×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Voornaam *</label>
                  <input type="text" value={formData.voornaam} onChange={(e) => setFormData({...formData, voornaam: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Achternaam *</label>
                  <input type="text" value={formData.achternaam} onChange={(e) => setFormData({...formData, achternaam: e.target.value})} required />
                </div>
              </div>
              <div className="form-group">
                <label>Gebruikersnaam *</label>
                <input type="text" value={formData.gebruikersnaam} onChange={(e) => setFormData({...formData, gebruikersnaam: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required />
              </div>
              <div className="form-group">
                <div style={{ padding: '12px 14px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', fontSize: '13px', color: '#1e40af' }}>
                  ℹ️ De nieuwe gebruiker krijgt een e-mail met een link om zelf een wachtwoord in te stellen.
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Rol *</label>
                  <select value={formData.rol_id} onChange={(e) => setFormData({...formData, rol_id: parseInt(e.target.value)})} required>
                    {rollen.map(rol => (<option key={rol.id} value={rol.id}>{rol.naam}</option>))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Afdeling</label>
                  <select value={formData.afdeling_id} onChange={(e) => setFormData({...formData, afdeling_id: e.target.value})}>
                    <option value="">Geen afdeling</option>
                    {afdelingen.map(afd => (<option key={afd.id} value={afd.id}>{afd.naam}</option>))}
                  </select>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">Annuleren</button>
                <button type="submit" className="btn-primary">Gebruiker Aanmaken</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default GebruikersBeheer;
